import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NgxCurrencyDirective } from 'ngx-currency';

import { AlertCardComponent } from '@shared/components/alert-card/alert-card.component';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';
import { AbntPipe } from '@shared/pipes/abnt.pipe';
import { MaskService } from '@shared/services/mask.service';

/**
 * Aba "ICMS DIFAL" do modal do item da venda (cópia da aba DIFAL do item da NF-e de
 * saída). O grupo não tem liga/desliga: ele é gerado quando a operação é interestadual
 * para consumidor final não contribuinte, e os campos ficam sempre à mostra.
 */
@Component({
    selector: 'app-vd-item-aba-difal',
    standalone: true,
    imports: [
        AbntPipe,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        NgxCurrencyDirective,
        AlertCardComponent,
        EmptyStateComponent,
    ],
    templateUrl: './vd-item-aba-difal.component.html',
    styleUrls: ['../abas-comum.css', './vd-item-aba-difal.component.css'],
})
export class VdItemAbaDifalComponent {
    /** O grupo `difal` do item. */
    @Input({ required: true }) public form!: FormGroup;
    @Input() public isRecalculoPendente: boolean = false;

    public readonly percentMask = this.maskService.getPercentMask();
    public readonly valorMask = this.maskService.getCurrencyMask(2);

    constructor(private maskService: MaskService) {}
}
